import { render } from "./ConfigurationsView.vue?vue&type=template&id=4edcf60d&scoped=true&ts=true"
import script from "./ConfigurationsView.vue?vue&type=script&lang=ts"
export * from "./ConfigurationsView.vue?vue&type=script&lang=ts"

import "./ConfigurationsView.vue?vue&type=style&index=0&id=4edcf60d&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edcf60d"]])

export default __exports__